// extracted by mini-css-extract-plugin
module.exports = {"video-contain":"DemoVideoSection_video-contain__yTTRX","video":"DemoVideoSection_video__1ZGia"};